/* KS · Pre-order (6 Oct 2026, Morris restock).
   Loaded by snippets/ks-preorder only when at least one variant is a pre-order; window.ksPreorder holds
   { ids: { "<variant id>": pre-orders left }, key, val, t: { tag, title, text, button, ship, hint } }.
   1. Every /cart/add (fetch JSON, FormData, form-encoded, plain form submit) gets the line property
      "<key>: <val>" (e.g. "Pre-order: verzonden vanaf 16 oktober") for pre-order variants, so the date shows
      in the cart, checkout, order confirmation and Picqer.
   2. Labels the pre-order sizes wherever they are sold: product page (notice above the buy button, button text,
      shipping row of the promise panel, sticky bar), pack upsell, quick add, the bundle builder copies on
      /pages/william-morris-bundel, the Morris landing page and the gift box builder. Idempotent; re-runs on
      variant changes and DOM changes. Liquid already tags the PDP sizes, the theme builder and the cart lines. */
(function () {
  'use strict';
  var PO = window.ksPreorder;
  if (!PO || !PO.ids) return;
  var T = PO.t || {};
  function isPO(id) { id = String(id || ''); return id !== '' && id !== '_' && Object.prototype.hasOwnProperty.call(PO.ids, id); }
  function withProp(props) { var o = {}; if (props) for (var k in props) o[k] = props[k]; o[PO.key] = PO.val; return o; }
  var PROP_NAME = 'properties[' + PO.key + ']';

  /* ---- 1. cart line property ---- */
  var ADD_RE = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (ADD_RE.test(url) && init && init.body) {
          var b = init.body;
          if (typeof b === 'string') {
            var s = b.trim();
            if (s.charAt(0) === '{') {
              var j = JSON.parse(s), hit = false;
              if (Array.isArray(j.items)) j.items.forEach(function (it) { if (isPO(it.id)) { it.properties = withProp(it.properties); hit = true; } });
              else if (isPO(j.id)) { j.properties = withProp(j.properties); hit = true; }
              if (hit) init = Object.assign({}, init, { body: JSON.stringify(j) });
            } else {
              var p = new URLSearchParams(s);
              if (isPO(p.get('id'))) { p.set(PROP_NAME, PO.val); init = Object.assign({}, init, { body: p.toString() }); }
            }
          } else if (typeof FormData !== 'undefined' && b instanceof FormData) {
            if (isPO(b.get('id'))) b.set(PROP_NAME, PO.val);
          } else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
            if (isPO(b.get('id'))) b.set(PROP_NAME, PO.val);
          }
        }
      } catch (e) { /* never block an add */ }
      return nativeFetch.call(this, input, init);
    };
  }
  /* plain form posts (and forms Impact turns into FormData): add a hidden input before the form is read */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || !ADD_RE.test(f.action)) return;
    var idEl = f.querySelector('[name="id"]');
    var old = f.querySelector('input[data-ks-po-prop]');
    if (idEl && isPO(idEl.value)) {
      if (!old) { old = document.createElement('input'); old.type = 'hidden'; old.name = PROP_NAME; old.setAttribute('data-ks-po-prop', ''); f.appendChild(old); }
      old.value = PO.val;
    } else if (old) { old.remove(); }
  }, true);

  /* ---- 2. labels ---- */
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function tagEl() { var t = document.createElement('span'); t.className = 'ks-po-tag'; t.textContent = T.tag; return t; }
  function addTag(el) { if (el && !el.querySelector('.ks-po-tag')) el.appendChild(tagEl()); }
  function addHint(after, key) {
    if (!after || !after.parentNode) return;
    var n = after.nextElementSibling;
    if (n && n.classList.contains('ks-po-hint')) return;
    var p = document.createElement('p'); p.className = 'ks-po-hint'; p.textContent = T.hint; p.setAttribute('data-ks-po-hint', key || '');
    after.parentNode.insertBefore(p, after.nextSibling);
  }
  var NOTE_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="7" width="13" height="10" rx="1"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>';
  function noteEl() {
    var d = document.createElement('div'); d.className = 'ks-po-note'; d.setAttribute('role', 'status');
    d.innerHTML = NOTE_ICON + '<div><b></b><span></span></div>';
    d.querySelector('b').textContent = T.title; d.querySelector('span').textContent = T.text;
    return d;
  }
  /* swap the visible label of a button without touching its structure (Impact's custom-button keeps a spinner) */
  var labels = new WeakMap();
  function textNodeOf(btn) {
    var w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null), n, last = null;
    while ((n = w.nextNode())) { if (n.nodeValue.trim() && !(n.parentNode.closest && n.parentNode.closest('.ks-po-tag'))) last = n; }
    return last;
  }
  function setLabel(btn, on) {
    var n = textNodeOf(btn); if (!n) return;
    var saved = labels.get(btn);
    if (on) {
      if (n.nodeValue.trim() === T.button) return;
      labels.set(btn, n.nodeValue); n.nodeValue = T.button;
    } else if (saved != null && n.nodeValue.trim() === T.button) {
      n.nodeValue = saved; labels.delete(btn);
    }
  }
  function formVariant(form) { var i = form && form.querySelector('[name="id"]'); return i ? i.value : ''; }

  function pdp() {
    $$('.product-info__buy-buttons').forEach(function (wrap) {
      var btn = wrap.querySelector('button[type="submit"]');
      var form = btn && (btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form'))));
      if (!form) return;
      var on = isPO(formVariant(form));
      var note = wrap.previousElementSibling && wrap.previousElementSibling.classList.contains('ks-po-note') ? wrap.previousElementSibling : null;
      if (on && !note) wrap.parentNode.insertBefore(noteEl(), wrap);
      if (!on && note) note.remove();
      $$('button[type="submit"]', wrap).forEach(function (b) { setLabel(b, on); });
      if (form.id) $$('.ks-sticky__btn button[form="' + form.id + '"]').forEach(function (b) { setLabel(b, on); });
      /* the promise panel's shipping row ("Voor 23:30 besteld, morgen in huis") -> the pre-order date */
      var scope = wrap.closest('.product-info, product-info, .product') || document;
      $$('[data-ks-promise][data-ks-icon="truck"], [data-ks-promise="verzending"]', scope).forEach(function (li) {
        var sp = li.querySelector('span'); if (!sp) return;
        if (on) {
          if (!li.hasAttribute('data-ks-po-orig')) li.setAttribute('data-ks-po-orig', sp.textContent);
          if (sp.textContent !== T.ship) sp.textContent = T.ship;
          li.classList.add('ks-po-ship');
        } else if (li.hasAttribute('data-ks-po-orig')) {
          sp.textContent = li.getAttribute('data-ks-po-orig'); li.removeAttribute('data-ks-po-orig'); li.classList.remove('ks-po-ship');
        }
      });
    });
  }

  function sizes() {
    /* builder markup (theme builder is tagged in Liquid; the Morris bundle page builds the same markup in JS) */
    $$('[data-ks-bb-size][data-vid]').forEach(function (b) {
      if (!isPO(b.getAttribute('data-vid'))) return;
      b.classList.add('ks-po'); addTag(b);
      var group = b.closest('[data-ks-bb-sizes]') || b.parentNode; addHint(group, 'bb');
    });
    /* pack upsell on the product page */
    $$('button[data-pbu-variant]').forEach(function (b) {
      if (!isPO(b.getAttribute('data-pbu-variant'))) return;
      addTag(b);
    });
    /* quick add (collection cards, cart recommendations): one form per size */
    $$('.ks-qa__sizes').forEach(function (box) {
      var any = false;
      $$('form', box).forEach(function (f) { if (isPO(formVariant(f))) { any = true; addTag(f.querySelector('button')); } });
      if (any) addHint(box, 'qa');
    });
    /* Morris landing page: radio inputs with data-variant inside .k-size labels, forms [data-buy] */
    $$('input[data-variant]').forEach(function (inp) {
      if (!isPO(inp.getAttribute('data-variant'))) return;
      var lab = inp.closest('.k-size') || inp.closest('label') || (inp.id && document.querySelector('label[for="' + inp.id + '"]'));
      if (lab) { lab.classList.add('ks-po-size'); addTag(lab); }
    });
    /* Morris page buy boxes: the scarcity notice sits between the sizes and the button while a pre-order size is chosen */
    $$('[data-buy]').forEach(function (form) {
      var checked = form.querySelector('input[data-variant]:checked');
      var on = !!(checked && isPO(checked.getAttribute('data-variant')));
      var btn = form.querySelector('button[type="submit"]');
      /* the 4-pack box (sizes named ksm-size-pack) tells the whole story; the single cards get one short line */
      var big = !!form.querySelector('input[name="ksm-size-pack"]');
      var note = form.querySelector('.ks-po-note, .ks-po-short');
      if (on && !note && btn) {
        if (big) {
          note = noteEl(); note.querySelector('b').textContent = T.pageTitle || T.title; note.querySelector('span').textContent = T.pageText || T.text;
        } else {
          note = document.createElement('p'); note.className = 'ks-po-short'; note.setAttribute('role', 'status'); note.textContent = T.pageShort || T.hint;
        }
        /* pack: under the button (Tako 6 Oct); singles: the short line above it */
        btn.parentNode.insertBefore(note, big ? btn.nextSibling : btn);
      }
      if (!on && note) note.remove();
      if (btn && !btn.disabled) setLabel(btn, on);
    });
    /* gift box builder cards: a hint naming the pre-order size(s) */
    $$('[data-ks-gb-card][data-sizes]').forEach(function (card) {
      if (card.querySelector('.ks-po-hint')) return;
      var list = []; try { list = JSON.parse(card.getAttribute('data-sizes') || '[]'); } catch (e) {}
      var po = list.filter(function (s) { return isPO(s.v); }).map(function (s) { return s.s; });
      if (!po.length) return;
      var p = document.createElement('p'); p.className = 'ks-po-hint'; p.textContent = po.join(' / ') + ': ' + T.hint;
      card.appendChild(p);
    });
  }

  var busy = false, queued = false;
  function run() {
    if (busy) { queued = true; return; }
    busy = true;
    try { pdp(); sizes(); } catch (e) { /* labels are best-effort */ }
    busy = false;
    if (queued) { queued = false; schedule(); }
  }
  var timer = 0;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 80); }

  document.addEventListener('variant:change', schedule, true);
  document.addEventListener('product:rerender', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.nodeType === 1 && (t.classList.contains('ks-po-tag') || t.classList.contains('ks-po-hint') || t.classList.contains('ks-po-note'))) continue;
      schedule(); return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
